import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute: React.FC = () => {
  const { user, token, loading } = useAuth();

  if (loading) {
    // Show loading indicator while checking auth status
    // You might want a more sophisticated loading spinner here later
    return <div>Loading...</div>;
  }

  // Check if user is logged in (either user object exists or token exists)
  // Checking the token might be slightly more robust during initial load phases
  const isAuthenticated = !!user || !!token;

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

export default PrivateRoute;
